import { ColumnFilter } from './columnFilter';
import { SortInfo } from './sortInfo';

export class PreviewDataOptions {
    filters?: ColumnFilter[];
    pageIndex: number;
    rowsPerPage: number;
    startRow: number;
    stopRow: number;
    showPriorData: boolean;
    sortInfo?: SortInfo[];

    constructor(pageIndex: number, rowsPerPage: number, sortInfo?: SortInfo[], filters?: ColumnFilter[]) {
      this.pageIndex = pageIndex;
      this.rowsPerPage = rowsPerPage;
      this.sortInfo = sortInfo;
      this.filters = filters;
    }
}
